import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import OptionalCard from 'components/molecules/OptionalCard';
import { CardTypes } from 'defs/card-types';
import { getPreviewImage, getText, getTitle, mapBackendType } from 'store/optionalProgramItems';
import { actionCreators as itemAC } from 'store/programItems';
import { actionCreators as transientPoolAC, getDayRef } from 'store/transientPoolState';
// import { CardTypeTypes } from 'types/Card';
// import { OptionalProgramItemsEnum } from 'types/services/magnolia/enums/OptionalProgramItemsEnum';

export type WorkoutOptionalContainerPropsType = {
	dayRef?: string;
};

const mapStateToProps = (state, ownProps) => {
	const type = mapBackendType(ownProps.id);

	if (!type) {
		return {};
	}

	return {
		...ownProps,
		type: CardTypes.Workout,
		categoryIcon: CardTypes.Workout,
		state: 'feed',
		itemType: type,
		dayRef: getDayRef(state), // used for replace endpoint from pools
		title: getTitle(state, type),
		text: getText(state, type),
		previewImage: getPreviewImage(state, type),
	};
};

const mapDispatchToProps = (dispatch) => {
	return bindActionCreators(
		{
			...itemAC,
			doSetProgramItemRef: transientPoolAC.doSetProgramItemRef,
			doSetDayRef: transientPoolAC.doSetDayRef,
		},
		dispatch
	);
};

export default connect(mapStateToProps, mapDispatchToProps)(OptionalCard);
